
import { Tooltip as ReactTooltip } from "react-tooltip";
import CountUp from 'react-countup';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from "react";
export default function TrainingDashboard() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const data = {
    title: "Career Compass",
    
    stats: {
      university: 13,
      tots: 55,
      Achievement: 2463,
      Target:3000
    },
    
  };

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-8">
     
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{data.title}</h1>
        <p className="text-gray-600">Your guide to navigate the transition from campus to career.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div 
          className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FE5D26]"
          data-tooltip-id="university-tooltip"
        >
         <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Training Of Trainers</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.tots} duration={2} />
              </h3>
              
            </div>
             <div className="flex flex-col items-center justify-center">
      <div className="bg-[#FFE9E1] p-3 rounded-full">
        <svg className="w-6 h-6 text-[#FE5D26]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <p className="text-[10px] font-semibold text-orange-600 mt-2">20% Female</p>
    </div>
          </div>
          <ReactTooltip id="university-tooltip" place="top" effect="solid" className="max-w-xs">
            <div className="text-sm">
              <h4 className="font-bold mb-2">Participating Universities:</h4>
             
              </div>
          </ReactTooltip>

           </div>
     <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#E52020]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">University Involved</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.university} duration={2} />
              </h3>
            </div>
            <div className="bg-[#FFE5E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FE5D26]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              
            </div>
          </div>
        </div>     
           <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FFC107]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Target</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Target} duration={2} separator="," />
              </h3>
            </div>
            <div className="flex flex-col items-center justify-center">
            <div className="bg-[#FFF8E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FFC107]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-[10px] font-semibold text-orange-600 mt-2">24% Female</p>
            </div>
          </div>
        </div>
       
        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FF9B45]">
        <div className="flex items-center justify-between">
        <div>
              <p className="text-sm font-medium text-gray-500">Achievement</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Achievement} duration={2} separator="," />
              </h3>
            </div>
      <div className="flex flex-col items-center justify-center">
      <div className="bg-[#FFE9E1] p-3 rounded-full">
        <svg className="w-6 h-6 text-[#FF9B45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
      </div>
      <p className="text-[10px] font-semibold text-orange-600 mt-2">20% Female</p>
    </div>
    </div>
    </div> 
    </div>

  <div className="bg-white p-2 rounded-xl shadow-md mb-8">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Career Compass Training Impact Overview</h3>
     <div className="mt-6 p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-700 italic"> 
        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-700 italic">"This insight showcases notable improvements in career awareness and decision-making skills based on pre- and post-survey assessments of 374 trainees. These findings demonstrate the Career Compass program’s effectiveness in guiding participants toward informed and focused career paths."</p>
    </div></p>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
      <div className="p-4">
        <div className="text-3xl font-bold text-[#FE5D26]">33% → 89%</div>
        <p className="text-sm text-gray-600 mt-2">Career exploration strategies</p>
      </div>
      <div className="p-4">
        <div className="text-3xl font-bold text-[#FF9B45]">63% → 88%</div>
        <p className="text-sm text-gray-600 mt-2">Confidence in chosen career path</p>
      </div>
      <div className="p-4">
        <div className="text-3xl font-bold text-[#4A90E2]">59% → 89%</div>
        <p className="text-sm text-gray-600 mt-2">Well-defined career goals</p>
      </div>
      <div className="p-4">
        <div className="text-3xl font-bold text-[#8BC34A]">43% → 84%</div>
        <p className="text-sm text-gray-600 mt-2">Career planning skills</p>
      </div>
    </div>
  </div>
         <div className="mt-6">
  <h4 className="text-md font-semibold text-gray-700 mb-2">Highlights from the Program</h4>
  <Slider
    dots={false}
    infinite={true}
    speed={500}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={false}
    className="mx-4"
  >
    {[
      "/assets/esjr1.jpg",
      "/assets/daap1.jpg",
      "/assets/daap3.jpg",
      "/assets/daap4.jpg",
    ].map((src, index) => (
      <div key={index} className="px-2">
        <img
          src={src}
          alt={`Slide ${index + 1}`}
          className="rounded-lg shadow-md h-40 w-full object-cover"
        />
      </div>
    ))}
  </Slider>
</div>
    </div>
    
  );
}